(function () {
  'use strict';

  var script = document.currentScript;
  var context = {
    template: script && script.dataset.template ? script.dataset.template : 'unknown',
    themeId: script && script.dataset.themeId ? script.dataset.themeId : 'unknown',
    release: script && script.dataset.release ? script.dataset.release : 'unknown',
    device: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
  };
  var budgets = { LCP: 2500, INP: 200, CLS: 0.1 };
  var values = { LCP: 0, INP: 0, CLS: 0 };
  var reported = {};

  function publish(name, value) {
    if (!value || reported[name]) return;
    reported[name] = true;

    var detail = Object.assign({}, context, {
      metric: name,
      value: Math.round(value * 1000) / 1000,
      budget: budgets[name],
      withinBudget: value <= budgets[name]
    });

    window.dispatchEvent(new CustomEvent('cacb:web-vital', { detail: detail }));

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('cacb_core_web_vital', detail);
      }
    } catch (error) {
      // A custom pixel subscription is optional; measurement continues locally.
    }

    try {
      sessionStorage.setItem('cacb-web-vital:' + context.template + ':' + name, JSON.stringify(detail));
    } catch (error) {
      // Storage may be unavailable in privacy modes.
    }
  }

  function observe(type, callback, options) {
    if (!('PerformanceObserver' in window) || PerformanceObserver.supportedEntryTypes.indexOf(type) === -1) return;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(callback);
      }).observe(Object.assign({ type: type, buffered: true }, options || {}));
    } catch (error) {
      // Older browsers may not accept durationThreshold or buffered options.
    }
  }

  observe('largest-contentful-paint', function (entry) {
    values.LCP = entry.startTime;
  });

  observe('event', function (entry) {
    if (entry.interactionId && entry.duration > values.INP) values.INP = entry.duration;
  }, { durationThreshold: 40 });

  observe('layout-shift', function (entry) {
    if (!entry.hadRecentInput) values.CLS += entry.value;
  });

  function reportAll() {
    publish('LCP', values.LCP);
    publish('INP', values.INP);
    publish('CLS', values.CLS);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') reportAll();
  });
  window.addEventListener('pagehide', reportAll);
  window.setTimeout(reportAll, 10000);

  function tuneReviewMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.jdgm-widget img, .jdgm-widget iframe, .jdgm-carousel-wrapper img, .jdgm-carousel-wrapper iframe').forEach(function (media) {
      media.loading = 'lazy';
      if (media.tagName === 'IMG') {
        media.decoding = 'async';
        media.fetchPriority = 'low';
      }
    });
  }

  tuneReviewMedia(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) tuneReviewMedia(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

